





























































































































import {Component, Vue} from 'vue-property-decorator'
import LoadingDummy from '../components/LoadingDummy.vue'
import {User} from '../models/User'
import router from '../router'
import Helper from '../services/Helper.js'

@Component({
  components: {LoadingDummy},
})
export default class ViewProfile extends Vue {

  show_password = false
  isSave = false
  snackbar = false
  snackbar_text = ''
  snackbar_color = ''
  password1 = ''
  password2 = ''


  changeDarkMode(dark: boolean) {
    this.$vuetify.theme.dark = dark
  }

  changeTheme() {

  }

  changeProfile() {

  }

  onFilePicked(e) {
    const fr = new FileReader()
    fr.readAsDataURL(e)
    fr.addEventListener('load', () => {
      this.$store.state.$user.picture = fr.result
      // debugger
    })
  }
  onSignaturePicked(e) {
    const fr = new FileReader()
    fr.readAsDataURL(e)
    fr.addEventListener('load', () => {
      this.$store.state.$user.signature = fr.result
      // debugger
    })
  }

  async save() {
    if (this.password1 != this.password2) {
      this.snackbar_text = 'รหัสผ่านไม่ตรงกัน'
      this.snackbar_color = 'red'
      this.snackbar = true
      return
    }


    this.isSave = true
    let user: User = this.$store.state.$user
    if (!user.hasOwnProperty('save')) {
      user = Object.setPrototypeOf(user, User.prototype)
    }
    try {
      if (this.password1) {
        user.password = this.password1
      }


      await user.save<User>()
      this.snackbar_text = 'บันทึกสำเร็จ'
      this.snackbar_color = 'green'
    } catch (e) {
      this.snackbar_text = e.toString()
      this.snackbar_color = 'red'
    }
    this.snackbar = true
    this.isSave = false
  }

  logout() {
    Helper.logOut()
    router.push('/login')
  }
}
